import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {ConstantsService} from "@app/services/constants/constants.service";

@Injectable({
    providedIn: 'root'
})
export class TimelineService {

    apiURL = environment.apiURL;

    constructor(private httpClient: HttpClient,
                private constantsService: ConstantsService) {
    }


    getAllForTable(filter, showAll, page, asc) {
        const creatorId = this.constantsService.getLoggedInUserId().toString();

        const params = new HttpParams()
            .set('filter', JSON.stringify(filter))
            .set('showAll', showAll)
            .set('creator', creatorId)
            .set('page', page.toString())
            .set('asc', asc);
        return this.httpClient.get(this.apiURL + '/task/getAllForTable', {params});
    }


    exportData(filter, showAll, asc) {
        const creatorId = this.constantsService.getLoggedInUserId().toString();

        const params = new HttpParams()
            .set('filter', JSON.stringify(filter))
            .set('showAll', showAll)
            .set('asc', asc)
            .set('creator', creatorId);
        return this.httpClient.get(this.apiURL + '/task/exportData', {params: params});
    }

}
